
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/pickup/gmc-sierra",
      function () {
        return require("private-next-pages/rims/pickup/gmc-sierra.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/pickup/gmc-sierra"])
      });
    }
  